import { createSlice } from "@reduxjs/toolkit";
import cloneDeep from "lodash/cloneDeep";

export const waterMarks = createSlice({
  name: "WaterMarks",
  initialState: {
    items: [],
    activeId: "",
    loaded: false,
    waterMarksloader: false,
    template: false,
    deletedWaterMarkIds: [],
  },
  reducers: {
    setItem: (state, action) => {
      const new_data = action.payload;
      const updated_data = [...state.items, new_data];
      state.items = updated_data;
      state.activeId = action.payload.id;
    },
    setScreenShot: (state, action) => {
      state.items = [action.payload];
      // state.activeId = action.payload.id;
    },
    setTemplateData: (state, action) => {
      state.items = action.payload;
    },
    setWaterMarksLoader: (state, action) => {
      state.waterMarksloader = action.payload;
    },
    setActiveId: (state, action) => {
      state.activeId = action.payload;
    },
    changeItemProperties: (state, action) => {
      const filtered_Data = state.items.filter(
        (data) => data.id !== action.payload.id
      );
      let filtered_item = state.items.filter(
        (data) => data.id === action.payload.id
      );
      filtered_item = cloneDeep(filtered_item);
      if (filtered_item.length && filtered_item[0].id === action.payload.id) {
        const new_data = { ...filtered_item[0], ...action.payload };
        const updated_data = [...filtered_Data, new_data];
        state.items = updated_data;
      }
    },
    setLoaded: (state, action) => {
      state.loaded = action.payload;
    },
    setTemplateLoaded: (state, action) => {
      state.template = action.payload;
    },
    deleteItem: (state, action) => {
      state.items = state.items.filter((item) => item.id !== action.payload.id);
      state.deletedWaterMarkIds = [
        ...state.deletedWaterMarkIds,
        action.payload.id,
      ];
    },
    deleteAll: (state) => {
      state.items = [];
      state.activeId = null;
      state.loaded = false;
      state.template = false;
      state.deletedWaterMarkIds = [];
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setItem,
  setScreenShot,
  setWaterMarksLoader,
  setActiveId,
  changeItemProperties,
  deleteItem,
  setTemplateData,
  deleteAll,
  setLoaded,
  setTemplateLoaded,
} = waterMarks.actions;

export default waterMarks.reducer;
